import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { EXPERIMENTS } from "@/data/playground";

export default function Playground() {
  return (
    <div data-testid="playground-page" className="pt-36 lg:pt-44 pb-24 lg:pb-32">
      <Seo
        title="Playground"
        description="Interactive experiments and playable prototypes by Nishant Gathwal — generative motion, games, and real-time creative toys built in the browser."
        path="/playground"
      />
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <Reveal>
          <p className="text-xs tracking-[0.2em] uppercase text-ash mb-5">Playground</p>
          <h1 className="font-heading font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-cream text-balance max-w-3xl">
            Experiments, toys & playable things.
          </h1>
          <p className="mt-6 max-w-xl text-ash text-lg leading-relaxed">
            A corner for real-time creativity — interaction studies, generative
            motion, and small games I build for the fun of it.
          </p>
        </Reveal>

        <div className="mt-12 border-b border-white/10">
          {EXPERIMENTS.map((e, i) => (
            <Reveal key={e.slug} delay={i * 0.05}>
              <Link
                to={`/playground/${e.slug}`}
                data-testid={`playground-card-${e.slug}`}
                className="group grid grid-cols-1 md:grid-cols-12 gap-5 md:gap-8 items-start border-t border-white/10 py-9 md:py-11 hover:bg-white/[0.02] transition-colors"
              >
                <div className="md:col-span-1">
                  <span className="font-heading text-sm text-ash tabular-nums">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="md:col-span-8">
                  <div className="flex flex-wrap items-center gap-3 text-xs text-ash mb-3">
                    <span className="rounded-full border border-white/15 px-2.5 py-0.5 text-cream/75">
                      {e.kind}
                    </span>
                    <span>{e.year}</span>
                  </div>
                  <h3 className="font-heading text-2xl md:text-3xl tracking-tight text-cream group-hover:text-white transition-colors inline-flex items-center gap-3">
                    {e.title}
                    <ArrowUpRight
                      size={22}
                      className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all text-ash"
                    />
                  </h3>
                  <p className="mt-3 text-ash leading-relaxed max-w-xl">{e.blurb}</p>
                </div>
                <div className="md:col-span-3 flex flex-wrap gap-2 md:justify-end">
                  {e.tags.map((t) => (
                    <span
                      key={t}
                      className="h-fit rounded-full border border-white/15 px-3 py-1 text-xs text-cream/70"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
